import Lobby from "../lobby/Lobby";
import { HeroProps } from "../HeroProps";
import { CommonHeroLayout } from "../layout/CommonHeroLayout";
import { useThumbnailSizing } from "../helpers";
import { MediaLobbyDataContainer } from "../lobby/lobby-data/LobbyData";
import { translate } from "@kaltura/mediaspace-shared-utils";

/**
 * wrapper component for Draft media
 */
const DraftHero = (props: HeroProps) => {
    const { thumbnailUrl, entry } = props;

    const statusLabel = translate("no media");

    const sizedThumbnailUrl = useThumbnailSizing(thumbnailUrl);

    return (
        <CommonHeroLayout collapsedHero={props.collapse}>
            <Lobby
                thumbnailUrl={sizedThumbnailUrl}
                statusLabel={statusLabel}
                title={entry.name}
                data={<MediaLobbyDataContainer {...props} />}
            />
        </CommonHeroLayout>
    );
};

export default DraftHero;
